import { ECMRDeliveryLineDto } from './ECMRDeliveryLineDto';

export class Route_eCMRDeliveryLinesDto {
	public lines: Array<ECMRDeliveryLineDto>;
	/***
	 * Totals: opcionals, viatgen sempre amb les línies (mateix "pack" i mateix
	 * reset). Si no s'informen, el servidor els calcula sumant "lines".
	 */
	public totalQuantity: number;
	public totalKg: number;
	public totalNetKg: number;
	public totalM3: number;
	public totalPalletCount: number;
	public totalBoxes: number;
	public totalBags: number;
	public totalSacks: number;
	public totalLitres: number;
	public reset: boolean;

	public static buildReset(): Route_eCMRDeliveryLinesDto {
		let result: Route_eCMRDeliveryLinesDto = new Route_eCMRDeliveryLinesDto();
		result.reset = true;
		return result;
	}

	public static build(lines: Array<ECMRDeliveryLineDto>): Route_eCMRDeliveryLinesDto {
		let result: Route_eCMRDeliveryLinesDto = new Route_eCMRDeliveryLinesDto();
		result.lines = lines;
		return result;
	}
}
